<template>
    <b-sidebar
        :id="sidebarId"
        title="Sidebar with backdrop"
        backdrop
        shadow
        no-header-close
        v-model="show"
        :no-slide="!show"
    >
        <template #header>
            <a
                href=""
                @click.prevent="getCurrentPosition"
            >
                <div class="img-wrapper">
                    <img
                        src="@/assets/sidebar_ic_location.svg"
                        alt="我的位置"
                    />
                </div>
                <div>我的位置</div>
            </a>
        </template>

        <ul class="sidebar-list">
            <li class="list-home">
                <a
                    class="d-block"
                    @click="goView('/')"
                >
                    <img
                        src="@/assets/menu_ic_home.png"
                        alt="首頁"
                    />首頁</a>
            </li>
            <li class="list-river">
                <a
                    class="d-block"
                    @click="goView('/river')"
                >
                    <img
                        src="@/assets/menu_ic_river.png"
                        alt="川流域事"
                    />川流城事</a>
            </li>
            <li class="list-news">
                <a
                    class="d-block"
                    @click="goView('/everything')"
                >
                    <i<img
                        src="@/assets/menu_ic_news.png"
                        alt="川柳大小事"
                    />川柳大小事
                </a>
            </li>
            <li class="list-guide">
                <a
                    class="d-block"
                    @click="goView('/guide')"
                >
                    <img
                        src="@/assets/menu_ic_guide.png"
                        alt="走讀河川"
                    />走讀河川</a>
            </li>
            <li class="list-game">
                <a
                    class="d-block"
                    @click="goView('/game')"
                >
                    <img
                        src="@/assets/menu_ic_game.png"
                        alt="互動遊戲"
                    />互動遊戲</a>
            </li>
            <li class="list-campaign">
                <a
                    class="d-block"
                    @click="goView('/campaign')"
                >
                    <!-- <i
                        class="fa fa-trophy"
                        aria-hidden="true"
                    ></i> -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        style="fill:#C28148;width:1.166rem;"
                    >
                        <path d="M572.1 82.38C569.5 71.59 559.8 64 548.7 64h-100.8c.2422-12.45 .1078-23.7-.1559-33.02C447.3 13.63 433.2 0 415.8 0H160.2C142.8 0 128.7 13.63 128.2 30.98C127.1 40.3 127.8 51.55 128.1 64H27.26C16.16 64 6.537 71.59 3.912 82.38C3.1 85.78-15.71 167.2 37.07 245.9c37.44 55.82 100.6 95.03 187.5 117.4c18.7 4.805 31.41 22.06 31.41 41.37C256 428.5 236.5 448 212.6 448H208c-26.51 0-47.99 21.49-47.99 48c0 8.836 7.163 16 15.1 16h223.1c8.836 0 15.1-7.164 15.1-16c0-26.51-21.48-48-47.99-48h-4.644c-23.86 0-43.36-19.5-43.36-43.35c0-19.31 12.71-36.57 31.41-41.37c86.96-22.34 150.1-61.55 187.5-117.4C591.7 167.2 572.9 85.78 572.1 82.38zM77.41 219.8C49.47 178.6 47.01 135.7 48.38 112h80.39c5.359 59.62 20.35 131.1 57.67 189.1C137.4 281.6 100.9 254.4 77.41 219.8zM498.6 219.8c-23.44 34.6-59.94 61.75-109 81.22C426.9 243.1 441.9 171.6 447.2 112h80.39C528.1 135.7 526.5 178.7 498.6 219.8z" />
                    </svg>
                    數位集章</a>
            </li>
            <li class="list-carbonFootprint">
                <a
                    class="d-block"
                    @click="goView('/carbon')"
                >
                    <img src="@/assets/menu_leaves.png" alt="icon">
                    碳跡川行</a>
            </li>
        </ul>
    </b-sidebar>
</template>

<script>
export default {
    props: {
        sidebarId: {
            type: String,
            default: 'sidebar',
        },
    },
    data() {
        return {
            show: false,
        };
    },
    methods: {
        getCurrentPosition() {
            this.$emit('get-current-position');
            this.show = false;
        },
        goView(link) {
            this.$router.push(link).catch(() => {
                this.show = false;
            });
            this.hideMap();
        },
        hideMap() {
            this.$emit('hide-map');
        },
    },
    beforeRouteEnter() {
        this.show = false;
    },
};
</script>

<style lang="sass" scoped>
@import '@/sass/_variable'

#sidebar
    width: 230px
    .b-sidebar-header,.b-sidebar-body
        background-color: $white
        color: $text-color
    .b-sidebar-header
        padding: 0
        a
            color: $text-color
            display: block
            text-align: center
            width: 100%
            font-size: 1rem
            margin: 3em 0
            text-decoration: none
            .img-wrapper
                border-radius: 50%
                box-shadow: 0px 2px 3px rgba(0,0,0,.3)
                border: 2px solid #83C0E9
                width: 46px
                height: 46px
                margin: 0 auto 10px auto
                display: flex
                justify-content: center
                align-items: center
    .sidebar-list
        list-style: none
        padding: 0 11px
        font-size: 1rem
        margin: 0
        li
            margin-bottom: 12px
            a
                display: block
                color: $text-color
                text-decoration: none
                line-height: 3.125
                border-radius: 5px
                cursor: pointer
                &:hover
                    color: darken($text-color,10%)
                i,img,svg
                    color: #E8AC92
                    font-size: 1.3em
                    margin-left: 30px
                    margin-right: 13px
                    width: 24px
                    height: 24px
            &.list-home
                a
                    background-color: #FFF7F2
                    i
                        color: #E8AC92
            &.list-river
                a
                    background-color: #E8F3EC
                    i
                        color: #89B79D
            &.list-news
                a
                    background-color: #F0F8E1
                    i
                        color: #BDD39B
            &.list-guide
                a
                    background-color: #EEF8FF
                    i
                        color: #73B3E2
            &.list-game
                a
                    background-color: #FFFAEE
                    i
                        color: #A68870
            &.list-campaign
                a
                    background-color: #F9F2EC
                    i
                        color: #C28148
            &.list-carbonFootprint
                a
                    background-color: #F2F2F2
</style>
